import { Gender } from "@dcc/types/gender";
import { RiskLevel } from "@dcc/types/riskLevel";
import {
  NO_RISK_WEEKLY_UNITS,
  maxWeeklyDrinks
} from "@dcc/constants/drinkConstants";
import { roundToNDecimalPlaces } from "@dcc/common/rounding";

export const getRiskLevel = (
  totalWeeklyUnits: number,
  gender: Gender
): RiskLevel => {
  if (totalWeeklyUnits <= NO_RISK_WEEKLY_UNITS) {
    return RiskLevel.Low;
  } else if (totalWeeklyUnits <= maxWeeklyDrinks[gender]) {
    return RiskLevel.Increasing;
  } else {
    return RiskLevel.High;
  }
};

export const getAmountAboveLowRisk = (
  riskLevel: number,
  totalWeeklyUnits: number
) =>
  riskLevel === RiskLevel.Low
    ? riskLevel
    : roundToNDecimalPlaces(
        roundToNDecimalPlaces(totalWeeklyUnits / NO_RISK_WEEKLY_UNITS, 2),
        1
      );
